import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemList from '../../Form/ItemList';
import { getDisplayDate } from '../../../libs/date';
import Spinner from '../../Spinner';
import { toJS } from 'mobx';

@inject('serverStore')
@observer
class ServerList extends Component {

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
  }

  render() {
    const { serverStore, children } = this.props;
    const { notify } = this.context;
    if (serverStore.isLoading) return <Spinner />;

    let items = toJS(serverStore.items).map(item => Object.assign({}, item, {
      last_sync: item.last_sync ? getDisplayDate(item.last_sync) : '-',
      sync: <a onClick={(e) => {
        e.preventDefault();
        serverStore.sync(item.id)
          .then(notify.success)
          .catch(notify.error);
      }}>Sync</a>
    }));


    return (
      <ItemList
        store={serverStore}
        data={items}
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'caption', label: 'Caption', searchable: true },
          { key: 'url', label: 'URL', searchable: true },
          { key: 'username', label: 'Username' },
          { key: 'last_sync', label: 'Last Sync' },
          { key: 'sync', label: '' },
        ]}
        slug={'configurations/server'}
        resource={'mms-agg'}
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />
    );
  }
}

export default ServerList;



// WEBPACK FOOTER //
// ./src/components/SystemConfiguration/Server/ServerList.js